import maNavbarCategorySpecific from '@/components/navbarCategoriesSpecific'
import maForm from '@/components/mobilierForm'
import maAddDamages from '@/components/button-blue'
import maDamagesCamera from '../damagesCamera'
import maNotificationsTop from '@/components/notifications-top'
import maInputFile from '@/components/input/modules/fileImg'
import maModal from '@/components/modal'
import maInputTxt from '@/components/input/modules/text'
import maDatePicker from '@/components/datePicker'
import moment from 'moment'
import maEventBus from '@/components/eventbus/index.js'
import maNavbarStepper from '@/components/navbarStepper'
import debounce from '@/utils/debounce'
import { mapState, mapMutations, mapActions } from 'vuex'
import { apiGetForm } from '@/modules/Damage/services/menus'
import {
  apiPatchDamage,
  apiPostDamageUptec,
  apiPostImage
} from '@/modules/Damage/services/damages'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_FORMS,
  WARRANTY_CLEAR_REPORT,
  WARRANTY_UPDATE_REPORT,
  WARRANTY_UPDATE_CATEGORIES_QTY,
  WARRANTY_UPDATE_CATEGORIES_MOBILIER,
  WARRANTY_CLEAR_FORMS,
  WARRANTY_UPDATE_DAMAGED_ITEM,
  WARRANTY_UPDATE_LITERALS_MOBILIER,
  WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
  WARRANTY_GET_SINISTER,
  WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
  WARRANTY_UPDATE_OBJ_UPTEC,
  WARRANTY_UPDATE_DAMAGED_ITEM_KEY
} from '@/store/types'
import {
  FEATURE,
  CPI,
  FORM_INPUTS_MOBILIER,
  FORM_UPTEC_FEATURE,
  FORM_UPTEC_CPI
} from '@/constants'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import userFlowMixin from '@/modules/User/mixins/userFlowMixin'
import { prepareErrorForSentry } from '@/utils/errorHandling'

export default {
  name: 'damageMobilierCategory3',

  mixins: [flowMixin, userFlowMixin],

  data: function () {
    return {
      formData: [],
      titleCategory: '',
      damage: {
        asset_damages: 0
      },
      activeInput: '',
      activeInputValue: '',
      addDamageBtnIsHidden: false,
      levels: {},
      formKey: 0,
      warrantySubtypeId: null,
      imgListEnsemble: [],
      imgListPres: [],
      formTemplate: {},
      error: false,
      errorMsg: '',
      poductId: null,
      formType: '',
      inputValPrice: null,
      inputValDate: '',
      errorDate: false,
      errorPrice: false,
      loading: false,
      isDisabledBtn: false,
      imgListNewCamera: [],
      noRequiredPhotos: false
    }
  },
  components: {
    maNavbarCategorySpecific,
    maForm,
    maAddDamages,
    maNotificationsTop,
    maInputFile,
    maModal,
    maInputTxt,
    maDatePicker,
    maDamagesCamera,
    maNavbarStepper
  },
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantyForms: 'forms',
      stateWarrantyCategoriesMobilier: 'categoriesMobilier',
      stateWarrantyCategoriesQty: 'categoriesQty',
      stateWarrantyDamagedItem: 'damagedItem',
      stateWarrantyCreated: 'created',
      stateWarrantySecondaryId: 'secondaryId',
      stateWarrantyAddress: 'address',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyMoreThanTwoYears: 'moreThanTwoYears',
      stateWarrantyPropertyType: 'propertyType',
      stateWarrantyResidentType: 'residentType',
      stateWarrantyaddress: 'address',
      stateWarrantyLiteralsMobilier: 'literalsMobilier',
      stateWarrantySubtypeId: 'subtypeId',
      stateWarrantyProductIdUptecFeature: 'productIdUptecFeature',
      stateWarrantyDamagedItemKey: 'damagedItemKey',
      stateWarrantyObjUptec: 'objUptec',
      stateWarrantyKeysMobilier: 'keysMobilier',
      stateWarrantyDamagedPartKey: 'damagedPartKey'
    }),
    getBtnType() {
      return this.loading ? 'spinnerBtn' : 'functionalBtn'
    },

    flowName() {
      return this.getUserFlow
    },
    showDateWithCorrectForm() {
      let date = moment(this.inputValDate, 'YYYY-MM-DD')
      let newFormat = date.format('DD-MM-YYYY')
      return newFormat
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyClearReport: WARRANTY_CLEAR_REPORT,
      mutWarrantyClearForms: WARRANTY_CLEAR_FORMS,
      mutWarrantyUpdateReport: WARRANTY_UPDATE_REPORT,
      mutWarrantyUpdateCategoriesQty: WARRANTY_UPDATE_CATEGORIES_QTY,
      mutWarrantyUpdateCategoriesMobilier: WARRANTY_UPDATE_CATEGORIES_MOBILIER,
      mutWarrantyUpdateDamagedItem: WARRANTY_UPDATE_DAMAGED_ITEM,
      mutWarrantyUpdateLiteralsMobilier: WARRANTY_UPDATE_LITERALS_MOBILIER,
      mutWarrantyUpdateTextSearchMobilier: WARRANTY_UPDATE_TEXT_SEARCH_MOBILIER,
      mutWarrantyUpdateCategFinalLevel: WARRANTY_UPDATE_CATEG_FINAL_LEVEL,
      mutWarrantyUpdateObjUptec: WARRANTY_UPDATE_OBJ_UPTEC,
      mutWarrantyUpdateDamagedItemKey: WARRANTY_UPDATE_DAMAGED_ITEM_KEY
    }),
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetForms: WARRANTY_GET_FORMS,
      actWarrantyGetSinister: WARRANTY_GET_SINISTER
    }),

    /**
     * Checks if there is inputValDate and sets the errorDate prop to true of false
     */
    checkInputDateValue() {
      if (this.inputValDate) {
        this.errorDate = false
      } else {
        this.errorDate = true
      }
    },

    /**
     * Sets the inputValDate with the value of the data picker only that formated
     */
    handleChangeInputDate(value) {
      this.inputValDate = moment(value).format('YYYY-MM-DD')
    },

    /**
     * Checks if the format of the price is correct and if not it sets it to the correct format
     */
    checkInputPriceFormat(valuePrice) {
      const priceIntegr = parseInt(valuePrice)
      if (isNaN(priceIntegr)) {
        this.errorPrice = true
      } else {
        this.errorPrice = false
        this.inputValPrice = Math.trunc(priceIntegr)
      }
    },

    /**
     * Cheks if there is input date value and if there is no errorDate of errorPrice it will open the confirmation modal
     */
    handleOpenModal() {
      this.checkInputDateValue()
      if (!this.errorDate && !this.errorPrice) {
        this.$refs.modalConfirmation.showModal = true
      }
    },

    /**
     * Cheks if there is input date value and if there is no errorDate of errorPrice it will open the confirmation modal feature
     */
    handleOpenModalFeature() {
      this.checkInputDateValue()
      if (!this.errorDate) {
        this.$refs.modalConfirmationFeature.showModal = true
      }
    },

    closeModaConfirmation() {
      this.$refs.modalConfirmation.showModal = false
      // this.$refs.modalConfirmation.showModal = false
    },

    closeModaConfirmationFeature() {
      this.$refs.modalConfirmationFeature.showModal = false
    },

    /**
     * Removes the last literal and the last category added in the previous view and goes t the previous view
     */
    handleClickPrevPage() {
      const lastLiteral =
        Object.values(this.stateWarrantyLiteralsMobilier).length - 1
      const keyLastLiteral = Object.keys(this.stateWarrantyLiteralsMobilier)[
        lastLiteral
      ]
      this.mutWarrantyUpdateCategFinalLevel(false)
      delete this.stateWarrantyCategoriesMobilier[
        this.stateWarrantyDamagedItemKey
      ]
      this.mutWarrantyUpdateDamagedItemKey(this.stateWarrantyKeysMobilier.cat1)
      delete this.stateWarrantyLiteralsMobilier[keyLastLiteral]
      this.goBack()
    },

    /**
     * Go to damage mobilier
     */
    goToDamageMobilier() {
      const damageMobilierViewName = 'damageMobilier'
      const propertyType = this.getPropertyType
      const damageType = this.getDamageType
      this.goToView(damageMobilierViewName, { propertyType, damageType })
    },

    /**
     * Filters the image arrays, deletes the imgSrc key
     */
    filterImageSrc() {
      // Overall picture
      this.imgListEnsemble.forEach((image) => {
        delete image.imgSrc
      })
      this.imgListPres.forEach((image) => {
        delete image.imgSrc
      })
    },

    async handleEnableButton() {
      let imgList = []
      imgList = [...imgList, ...this.imgListEnsemble, ...this.imgListPres]
      const imagesValidated = await this.checkImages(imgList)
      if (imagesValidated) {
        this.isDisabledBtn = false
      } else {
        this.isDisabledBtn = true
      }
    },

    checkImages(imgList) {
      if (
        !this.addDamagesHasImages ||
        Object.keys(imgList)[0] === '0' ||
        this.imgListNewCamera.length > 0 ||
        this.noRequiredPhotos
      )
        return true

      const imageTypes = [, /* 'inputImgEnsemble' */ 'inputImgPres']
      const imageListTypes = [
        ...new Set(imgList.map((image) => image.imageType))
      ]

      return imageTypes.every(
        (imageType) => imageListTypes.indexOf(imageType) > -1
      )
    },
    async handleAddDamages() {
      this.loading = true
      let imgList = []
      this.filterImageSrc()
      this.getSubwarrantyId()
      imgList = [
        /* ...imgList , */ ...this.imgListPres,
        ...this.imgListEnsemble
      ].filter(img => img != null)
      const imagesValidated = await this.checkImages(imgList)

      if (imagesValidated) {
        this.updateForm().then(() => {
          this.damage['asset_damages'] = this.formData.form.asset_damages

          const subTypeId = this.stateWarrantySubtypeId
            ? this.stateWarrantySubtypeId
            : localStorage.getItem('warranty_subtype_id')

          let damageBody
          if (this.imgListNewCamera.length > 0) {
            damageBody = {
              sinister_id: this.getSinisterId,
              event_id: this.stateWarrantySecondaryId,
              category: this.getWarrantyId,
              subcategory: subTypeId,
              form_info: { ...this.damage },
              images: this.imgListNewCamera
            }
            this.noRequiredPhotos = true
          } else {
            damageBody = {
              sinister_id: this.getSinisterId,
              event_id: this.stateWarrantySecondaryId,
              category: this.getWarrantyId,
              subcategory: subTypeId,
              form_info: { ...this.damage },
              images: imgList
            }
          }

          const postBody = {
            lat: this.stateWarrantyCoordinates.lat,
            lon: this.stateWarrantyCoordinates.lng,
            zip_code: this.stateWarrantyZipCode,
            real_estate: this.stateWarrantyPropertyType,
            declarant: this.stateWarrantyResidentType,
            more_than_two_years: this.stateWarrantyMoreThanTwoYears,
            address: this.stateWarrantyAddress
          }

          damageBody = {
            ...damageBody,
            ...postBody
          }

          // 400 campos faltan, 500 generico
          apiPatchDamage(damageBody)
            .then(() => {
              this.mutWarrantyClearForms()
              this.mutWarrantyClearReport()
              const damagesViewViewName = 'damages-view'
              this.goToView(damagesViewViewName)
            })
            .catch((error) => {
              this.loading = false
              this.error = true
              this.errorMsg = this.$t(
                `notifications.error.${error.response.status}.title`
              )

              const context = {
                component: 'damageMobilierCategory3',
                method: 'handleAddDamages',
                route: this.$route.path
              }

              const tags = prepareErrorForSentry(error, context)

              this.sendSentryError(
                `Error adding damage report: ${error.message || 'Unknown error'}`,
                error.response && error.response.status >= 500 ? 'error' : 'warning',
                tags,
                this.getWarrantyId,
                'handleAddDamages'
              )

              setTimeout(() => {
                this.error = false
              }, 2000)
            })
        })
      } else {
        this.loading = false
        window.scrollTo(0, 0)
        this.throwNotification(
          this.$t('claim.details.errorImages'),
          this.$t('claim.details.errorImages'),
          'KO'
        )
      }
    },

    /**
     * Damage is updated locally on input change.
     */
    handleFormChange: function (event) {
      if (event.inpTextNumbers) {
        const inputValParsed = event.inputVal.replace(',', '.')
        this.damage[event.inputId] = inputValParsed
      } else {
        this.damage[event.inputId] = event.inputVal
      }
      this.handleEnableButton()
    },

    /**
     * Debounced function (Important. Just first input event is catched). Form has to be updated always because rep_type_code changes depending on input value combination.
     */
    handleNestedComponents: debounce(function (event) {
      this.activeInputValue = event.inputVal
      this.updateForm()
    }, 250),

    updateForm: function () {
      const report = Object.assign({}, this.damage)
      delete report['asset_damages']

      const formInputs = document.querySelectorAll('.warranty__content input')
      formInputs.forEach((input) => (input.disabled = true))

      this.isDisabledBtn = true
      return apiGetForm(report, this.getWarrantyId)
        .then((data) => {
          // this.formData = null

          this.$nextTick(() => {
            this.formData = data

            Object.keys(this.stateWarrantyCategoriesMobilier).forEach((key) => {
              this.formData.form.regions[0].inputs =
                this.formData.form.regions[0].inputs.filter(
                  (input) => input.name !== key
                )
            })

            // Update hidden values
            this.formData.form.regions.forEach((region) => {
              region.inputs.forEach((input) => {
                if (input.selectedValue && !!input.self_care_hidden) {
                  this.damage[input.name] = input.selectedValue
                }
              })
            })

            // this always returns undefined as this.formDataForm doesnt exists.
            // but if we change it as we think it should be (this.formData.form...)
            // then it acts erratically when selecting some options in the form
            // as it breaks the code after the next line we decided to comment al the remaining code
            // -- this.formData.form.regions[0].inputs = this.formDataForm.form.regions[0].inputs.filter(input => input.type !== 'hidden')
            // console.log(this.formData);

            // this.setDefaultValuesForm()
            // this.$nextTick(this.handleUpdateForm)
          })
        })
        .catch((error) => {
          const context = {
            component: 'damageMobilierCategory3',
            method: 'updateForm',
            route: this.$route.path
          }

          const tags = prepareErrorForSentry(error, context)

          this.sendSentryError(
            `Error getting warranty form: ${error.message || 'Unknown error'}`,
            error.response && error.response.status >= 500 ? 'error' : 'warning',
            tags,
            this.getWarrantyId,
            'updateForm'
          )
        })
        .finally(() => {
          formInputs.forEach((input) => (input.disabled = false))
          this.isDisabledBtn = false
        })
    },

    /**
     * Sets the focus/blur for the active input
     */
    handleUpdateForm: function () {
      if (this.activeInput !== '') {
        const activeInputType = this.activeInput.getAttribute('type')
        const activeInputName = this.activeInput.getAttribute('name')
        const activeInputVal = this.activeInputValue
        // REFACTOR MOVER A FORM
        if (
          activeInputType === 'checkbox' &&
          this.activeInput.hasAttribute('isSelect')
        ) {
          document.querySelector('input[name=' + activeInputName + ']').focus()
          document.querySelector('input[name=' + activeInputName + ']').blur()
        } else if (activeInputType === 'text') {
          document.querySelector('input[name=' + activeInputName + ']').focus()
        } else {
          const el = document.querySelector(
            'input[value="' + activeInputVal + '"]'
          )
          if (el) el.focus()
        }
      }
    },

    /**
     * Sets the defauld values for each form when is updated - the input.selected values that come from the forms api
     */
    setDefaultValuesForm: function () {
      this.damage = {}
      this.damage.asset_damages = this.formData.form.asset_damages || ''

      this.formData.form.regions.forEach((region) => {
        region.inputs.forEach((input) => {
          if (input.selectedValue) {
            this.damage[input.name] = input.selectedValue
          }
        })
      })
    },

    /**
     * Sets the defauld values for each form when the view is printed - the input.selected values that come from the forms api
     */
    setDefaultValues: function () {
      this.damage = {}
      this.damage.asset_damages = this.formData.form.asset_damages || ''
      this.damage = Object.assign({}, this.stateWarrantyCategoriesMobilier)
      this.formData.form.regions.forEach((region) => {
        region.inputs.forEach((input) => {
          if (input.selectedValue) {
            this.damage[input.name] = input.selectedValue
          }
        })
      })
    },

    /**
     * Adds levels to the levels object
     */
    addLevels(form, key) {
      form.forEach((input) => {
        if (
          this.stateWarrantyCategoriesQty === 2 &&
          input.name === key &&
          input.name !== 'ASSETS'
        ) {
          if (!this.levels.level1) this.levels['level1'] = input.id
        } else if (
          this.stateWarrantyCategoriesQty === 3 &&
          input.name === key
        ) {
          if (!this.levels.level1) this.levels['level1'] = input.id
          if (!this.levels.level2 && this.levels.level1.id !== input.id) {
            this.levels['level2'] = input.id
          }
          if (
            !this.levels.level3 &&
            this.levels.level1.id !== input.id &&
            this.levels.level2.id !== input.id
          ) {
            this.levels['level2'] = input.id
          }
        }
      })
    },

    /**
     * Sets title category
     */
    setTitleCategory() {
      const lastLiteral =
        Object.values(this.stateWarrantyLiteralsMobilier).length - 1
      this.titleCategory = Object.values(this.stateWarrantyLiteralsMobilier)[
        lastLiteral
      ]
    },

    /**
     * Updates the state report, calls action actWarrantyGetForms to get the froms and sets the data for the forms, sets the default value inputs for the form
     */
    getForm() {
      this.mutWarrantyClearForms()
      let report = this.stateWarrantyCategoriesMobilier
      const warrantyId = this.getWarrantyId
      this.actWarrantyGetForms({ report, warrantyId }).then((res) => {
        if (res.formsUpdated) {
          this.formTemplate = Object.assign(this.stateWarrantyForms[0], {})
          this.filterForm()
        }
      })
      this.handleEnableButton()
    },
    /**
     * Adds the damage for the feature uptec mobilier
     */
    async handleAddDamagesFeatureUptec() {
      this.loading = true
      let imgList = []
      this.getUptecObj()
      this.filterImageSrc()
      this.getSubwarrantyId()
      imgList = [...imgList, ...this.imgListEnsemble, ...this.imgListPres]
      const imagesValidated = await this.checkImages(imgList)
      if (imagesValidated) {
        if (this.poductId && this.inputValDate) {
          let objDamage
          if (this.imgListNewCamera.length > 0) {
            objDamage = {
              sinister_id: this.getSinisterId,
              product_group_id: this.poductId,
              upptec_damage_type: 'FEATURE',
              date_of_purchase: this.inputValDate,
              images: this.imgListNewCamera
            }
          } else {
            objDamage = {
              sinister_id: this.getSinisterId,
              product_group_id: this.poductId,
              upptec_damage_type: 'FEATURE',
              date_of_purchase: this.inputValDate,
              images: imgList
            }
          }

          this.$refs.modalConfirmationFeature.showModal = false

          apiPostDamageUptec(objDamage)
            .then((res) => {
              let key = 'date'
              let value = res.date_of_purchase
              this.mutWarrantyUpdateObjUptec({ key, value })
              const depreciation = res.calculation_details.depreciation * 100
              key = 'depreciation'
              value = Math.trunc(depreciation)
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'indemnisation'
              value = res.calculation_details.compensation.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'totalPayment'
              value = res.calculation_details.current_market_price.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'images'
              value = res.images
              this.mutWarrantyUpdateObjUptec({ key, value })

              this.mutWarrantyClearForms()
              this.mutWarrantyClearReport()
              const damageResultUptecViewName = 'damage-result-uptec'
              this.goToView(damageResultUptecViewName)
            })
            .catch((error) => {
              this.loading = false
              this.error = true
              this.errorMsg = this.$t(
                `notifications.error.${error.response.status}.title`
              )

              const context = {
                component: 'damageMobilierCategory3',
                method: 'handleAddDamagesFeatureUptec',
                route: this.$route.path
              }

              const tags = prepareErrorForSentry(error, context)

              this.sendSentryError(
                `Error adding feature damage: ${error.message || 'Unknown error'}`,
                error.response && error.response.status >= 500 ? 'error' : 'warning',
                tags,
                this.getWarrantyId,
                'handleAddDamagesFeatureUptec'
              )

              setTimeout(() => {
                this.error = false
              }, 2000)
            })
        } else {
          this.loading = false
          this.error = true
          this.errorMsg = this.$t(`notifications.error.${400}.title`)
          setTimeout(() => {
            this.error = false
          }, 2000)
        }
      } else {
        this.loading = false
        this.$refs.modalConfirmationFeature.closeModal()
        window.scrollTo(0, 0)
        this.throwNotification(
          this.$t('claim.details.errorImages'),
          this.$t('claim.details.errorImages'),
          'KO'
        )
      }
    },

    getUptecObj() {
      let key = 'titleCat'
      let value = this.titleCategory
      this.mutWarrantyUpdateObjUptec({ key, value })
      key = 'titleCat'
      value = this.titleCategory
      this.mutWarrantyUpdateObjUptec({ key, value })
      key = 'cat2'
      value = this.stateWarrantyLiteralsMobilier.cat2
      this.mutWarrantyUpdateObjUptec({ key, value })
      key = 'cat1'
      value = this.stateWarrantyLiteralsMobilier.cat1
      this.mutWarrantyUpdateObjUptec({ key, value })
    },

    /**
     * Adds the damage for the cpi uptec mobilier
     */
    async handleAddDamagesCpi() {
      this.loading = true
      let imgList = []
      this.getUptecObj()
      this.filterImageSrc()
      this.getSubwarrantyId()
      imgList = [...imgList, ...this.imgListEnsemble, ...this.imgListPres]
      const imagesValidated = await this.checkImages(imgList)

      if (imagesValidated) {
        if (this.poductId && this.inputValDate && this.inputValPrice) {
          let objDamage
          if (this.imgListNewCamera.length > 0) {
            objDamage = {
              sinister_id: this.getSinisterId,
              product_group_id: this.poductId,
              upptec_damage_type: 'CPI',
              date_of_purchase: this.inputValDate,
              purchase_price: this.inputValPrice,
              images: this.imgListNewCamera
            }
          } else {
            objDamage = {
              sinister_id: this.getSinisterId,
              product_group_id: this.poductId,
              upptec_damage_type: 'CPI',
              date_of_purchase: this.inputValDate,
              purchase_price: this.inputValPrice,
              images: imgList
            }
          }

          this.$refs.modalConfirmation.showModal = false

          apiPostDamageUptec(objDamage)
            .then((res) => {
              let key = 'date'
              let value = res.date_of_purchase
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'price'
              value = res.purchase_price.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              const depreciation = res.calculation_details.depreciation * 100
              key = 'depreciation'
              value = Math.trunc(depreciation)
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'indemnisation'
              value = res.calculation_details.compensation.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'totalPayment'
              value = res.calculation_details.current_market_price.amount
              this.mutWarrantyUpdateObjUptec({ key, value })
              key = 'images'
              value = res.images
              this.mutWarrantyUpdateObjUptec({ key, value })
              this.mutWarrantyClearForms()
              this.mutWarrantyClearReport()
              const damageResultUptecViewName = 'damage-result-uptec'
              this.goToView(damageResultUptecViewName)
            })
            .catch((error) => {
              this.loading = false
              this.error = true
              this.errorMsg = this.$t(
                `notifications.error.${error.response.status}.title`
              )

              const context = {
                component: 'damageMobilierCategory3',
                method: 'handleAddDamagesCpi',
                route: this.$route.path
              }

              const tags = prepareErrorForSentry(error, context)

              this.sendSentryError(
                `Error adding CPI damage: ${error.message || 'Unknown error'}`,
                error.response && error.response.status >= 500 ? 'error' : 'warning',
                tags,
                this.getWarrantyId,
                'handleAddDamagesCpi'
              )

              setTimeout(() => {
                this.error = false
              }, 2000)
            })
        } else {
          this.loading = false
          this.error = true
          this.errorMsg = this.$t(`notifications.error.${400}.title`)
          setTimeout(() => {
            this.error = false
          }, 2000)
        }
      } else {
        this.loading = false
        this.$refs.modalConfirmation.showModal = false
        window.scrollTo(0, 0)
        this.throwNotification(
          this.$t('claim.details.errorImages'),
          this.$t('claim.details.errorImages'),
          'KO'
        )
      }
    },

    /**
     * Filters the form of hidden inputs and categories selected in previous views
     */
    filterForm() {
      this.setFormType()

      Object.keys(this.stateWarrantyCategoriesMobilier).forEach((key) => {
        this.formTemplate.form.regions[0].inputs =
          this.formTemplate.form.regions[0].inputs.filter((input) => {
            return input.name !== key
          })
      })
      this.formTemplate.form.regions[0].inputs =
        this.formTemplate.form.regions[0].inputs.filter((input) => {
          return input.type !== 'hidden'
        })
      this.formData = this.formTemplate

      const sinisterId = this.getSinisterId
      if (!this.stateWarrantySinisterId) this.actWarrantyGetSinister(sinisterId)
      this.setDefaultValues()
    },

    /**
     * Sets the focus when an input is modified
     */
    handleInputFocus: function () {
      const focusedInput = document.querySelector('input:focus')
      if (document.querySelector('input:focus') !== null) {
        this.activeInput = focusedInput
      }
    },

    /**
     * Gets the warranty id from local storage if it doesen't exist
     */
    getSubwarrantyId() {
      if (!this.stateWarrantySubtypeId) {
        this.warrantySubtypeId = localStorage.getItem('warranty_subtype_id')
      }
    },

    /**
     * Pushes the image in the imgListEnsemble array
     */
    handleImgChangeEnsemble(event) {
      const dataImg = event.fileData ? event.fileData : event
      this.imgListEnsemble.push(dataImg)
      this.handleEnableButton()
    },

    /**
     * Pushes the image in the imgListPres array
     */
    handleImgChangePres(event) {
      const dataImg = event.fileData ? event.fileData : event
      this.imgListPres.push(dataImg)
      this.handleEnableButton()
    },

    /**
     * Gets the target uptec option(subcategory) that was last selected, stateWarrantyCategoriesMobilier has all the selected categories selected from a product, and damagedItemKey is the key of the last selected category
     */
    getTargetUptecItem() {
      if (this.stateWarrantyCategoriesMobilier) {
        return this.stateWarrantyCategoriesMobilier[
          this.stateWarrantyDamagedItemKey
        ].toUpperCase()
      }
    },

    /**
     * Sets the form type, if the option is uptec damage and its type is cpi, it will get the targetUptecItem which is the last selected category to get the correct product id for this option, else if it's an uptec damage and the type is feature it will only set the form type and get the product id as there will be only one result for it, else it's the formInputsMobilier, the general form with its corresponding inputs
     */
    setFormType() {
      const formInput = this.formTemplate.form.regions[0].inputs.find(
        (input) => input.name === this.stateWarrantyDamagedItemKey
      )
      const formInputOption = formInput.options.find(
        (option) => option.key.toUpperCase() === this.getTargetUptecItem()
      )

      if (formInputOption.is_upptec_damage === false) {
        this.formType = FORM_INPUTS_MOBILIER
      } else {
        if (formInputOption.upptec_damage_type === FEATURE) {
          this.formType = FORM_UPTEC_FEATURE
          this.poductId = this.stateWarrantyProductIdUptecFeature
        } else if (formInputOption.upptec_damage_type === CPI) {
          this.formType = FORM_UPTEC_CPI
          this.poductId = formInputOption.upptec_product_group_id
        }
      }
    },

    handleOnShowModalCamera() {
      this.$refs.damagesCamera.showModal()
    },

    handleNoPhotosRequired() {
      this.noRequiredPhotos = true
    },

    async handleCameraPhotos(photos) {
      const sinisterId =
        this.stateWarrantySinisterId || sessionStorage.getItem('sinId')

      const photosParsed = photos.map((element, index) => {
        const [, ext] = element.split(';')[0].split('/')

        const imageContent = element.replace(/data:[A-z]*\/[A-z]*;base64,/, '')

        let imgBody = {
          imageName: `CameraFlow_${new Date().getTime() + index}.${ext}`,
          imageType: 'cameraFlow',
          imageContent: imageContent
        }
        return imgBody
      })

      const damagePartsPromises = []

      for (const imgBody of photosParsed) {
        damagePartsPromises.push(apiPostImage(sinisterId, imgBody))
      }

      const damagesImages = await Promise.all(damagePartsPromises).catch(
        this.showImageError
      )
      this.noRequiredPhotos = true
      this.imgListNewCamera = damagesImages
    }
  },
  watch: {
    inputValPrice(value) {
      if (value.length >= 1) this.checkInputPriceFormat(value)
    }
  },
  /**
   * Sets the title category and gets form
   */
  mounted() {
    this.mutWarrantyUpdateCategoriesQty(3)
    this.setTitleCategory()
    if (!this.stateWarrantyProductIdUptecFeature) {
      this.getForm()
    } else {
      this.formTemplate = Object.assign(this.stateWarrantyForms[0], {})
      this.filterForm()
    }

    maEventBus.$on('inputWarranty:focus', ($event) =>
      this.handleInputFocus($event)
    )
  }
}
